module.exports = __webpack_public_path__ + "static/img/info_t.8f2c6ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/info_t.jpg
// module id = pTmN
// module chunks = 101